import { useApiSend } from "@/hooks/useApi";
import { unlikeComment } from "../api";
import { useQueryClient } from "@tanstack/react-query";

export function useUnlikeComment({ comment }) {
	const { mutateAsync, isPending, isError, error } = useApiSend({
		fn: () => unlikeComment({ comment }),
		invalidateKeys: [["comments"]],
	});

	return { unlike: mutateAsync, isPending, error, isError };
}
